import React, { useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import * as Yup from "yup";
import { useFormik } from "formik";
import clsx from "clsx";
import { loginUser } from "../../services/auth.service";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useDispatch } from "react-redux";
import { setUserDetail } from "../../core/data/redux/user/userSlice";
import { LANG } from "../../constants/language";
import ErrorText from "../../core/components/error-text";
import { Form } from "react-bootstrap";
import { DEVICE_TYPE, emailRegex } from "../../constants/utlis";
import { decrypt, encrypt } from "../../constants/crypto";

const loginSchema = Yup.object().shape({
  // email: Yup.string().email(LANG.PLEASE_ADD_VALID_EMAIL).required(LANG.EMAIL_IS_REQUIRED),
  email: Yup.string()
    .required(LANG.EMAIL_IS_REQUIRED)
    .matches(emailRegex, LANG.PLEASE_ADD_VALID_EMAIL),
  password: Yup.string()
    .required(LANG.PASSWORD_IS_REQUIRED)
    .min(8, LANG.PASSWORD_MIN_LENGTH)
    .matches(/[A-Z]/, LANG.PASSWORD_UPPERCASE)
    .matches(/[a-z]/, LANG.PASSWORD_LOWERCASE)
    .matches(/[0-9]/, LANG.PASSWORD_NUMBER)
    .matches(/[@#%!-]/, LANG.PASSWORD_SYMBOL),
});

const Login = () => {
  const route = all_routes;

  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };
  const uaData = (navigator as any).userAgentData;
  const device_os = uaData?.platform || "Unknown OS";
  const app_version = uaData?.brands?.[0]
    ? `${uaData.brands[0].brand} ${uaData.brands[0].version}`
    : "Unknown Browser";

  const initialValues = {
    email: localStorage.getItem("remember_email") || "",
    password: decrypt(localStorage.getItem("remember_password") || ""),
    device_type: DEVICE_TYPE,
    device_model: "Desktop",
    device_os: device_os,
    app_version: app_version,
    rememberMe: localStorage.getItem("remember_email") ? true : false,
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const result = await loginUser(values);

        if (result.status == 200) {
          console.log("result ========= ", result.data?.data);

          localStorage.setItem("phone", result.data?.data?.phone);
          localStorage.setItem("uuid", result.data?.data?.uuid);
          dispatch(setUserDetail(result.data?.data));

          // Remember me functionality
          if (values.rememberMe) {
            localStorage.setItem("remember_email", values.email);
            localStorage.setItem("remember_password", encrypt(values.password));
          } else {
            localStorage.removeItem("remember_email");
            localStorage.removeItem("remember_password");
          }

          navigate(route.verificationOtp);
        } else if (result.status == 404) {
          console.log(values);
        }
        setSubmitting(false);
        setLoading(false);
      } catch (error) {
        if (error instanceof AxiosError) {
          toast.error(error.response?.data?.error);
        }
        console.log(error, loading);
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper authendication-pages">
        {/* Page Content */}
        <div className="content">
          <div className="container wrapper no-padding">
            <div className="row no-margin align-items-stretch">
              <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
                <div className="banner-bg login">
                  <div className="row h100 pb-0">
                    <div className="col-sm-10 col-md-12 col-lg-12">
                      <div className="row h-100">
                        <div className="col-md-12 h-100">
                          <img
                            src="/assets/img/authImg.jpg"
                            className="object-fit-cover img-fluid h-100 w-100"
                            alt="authImg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12  col-lg-4 no-padding d-flex">
                <div className="dull-pg shadow-card w-100">
                  <div className="row no-margin d-flex align-items-center justify-content-center">
                    <div className="col-sm-10 col-md-10 col-lg-11 mx-auto">
                      <header className="text-center">
                        <ImageWithBasePath
                          src="assets/img/logo.svg"
                          className="img-fluid"
                          alt="Logo"
                        />
                      </header>
                      <div className="">
                        <h2 className="text-center">
                          Sign in to your account!
                        </h2>
                        <p className="text-center">
                          Sign in with the details you used during registration.
                        </p>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            {/* Login Form */}
                            <form onSubmit={formik.handleSubmit}>
                              <div className="form-group">
                                <label>Email</label>
                                <div className="group-img iconLeft email position-relative">
                                  <input
                                    type="text"
                                    placeholder="Email"
                                    {...formik.getFieldProps("email")}
                                    className={clsx(
                                      "form-control commonInput bg-transparent",
                                      {
                                        "border border-danger":
                                          formik.touched.email &&
                                          formik.errors.email,
                                      }
                                    )}
                                  />
                                </div>
                                <ErrorText
                                  show={
                                    formik.touched.email && formik.errors.email
                                  }
                                  message={formik.errors?.email}
                                />
                              </div>
                              <div className="form-group">
                                <label>Password</label>
                                <div className="pass-group group-img  iconLeft email position-relative">
                                  <i
                                    className={`toggle-password ${passwordVisible ? "feather-eye" : "feather-eye-off"}`}
                                    onClick={togglePasswordVisibility}
                                    style={{
                                      borderLeft: "1px solid",
                                      paddingLeft: 14,
                                    }}
                                  />
                                  <input
                                    type={passwordVisible ? "text" : "password"}
                                    placeholder="Password"
                                    {...formik.getFieldProps("password")}
                                    className={clsx(
                                      "form-control commonInput pass-input bg-transparent",
                                      {
                                        "border border-danger":
                                          formik.touched.password &&
                                          formik.errors.password,
                                      }
                                    )}
                                  />
                                </div>
                                <ErrorText
                                  show={
                                    formik.touched.password &&
                                    formik.errors.password
                                  }
                                  message={formik.errors?.password}
                                />
                              </div>
                              <div className="form-group d-sm-flex align-items-center justify-content-between">
                                <div className="form-check user-login-check  d-flex align-items-center justify-content-start">
                                  <Form.Check
                                    aria-label="option 1"
                                    {...formik.getFieldProps("rememberMe")} // This binds checked + onChange
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="user-pass"
                                  >
                                    Remember me
                                  </label>
                                </div>
                                <span>
                                  <Link
                                    to={route.forgotPasssword}
                                    className="forgot-pass"
                                  >
                                    Forgot password
                                  </Link>
                                </span>
                              </div>
                              <button
                                type="submit"
                                className="btn btn-primary primaryButton register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                              >
                                {LANG.SIGN_IN}
                              </button>
                            </form>
                            {/* /Login Form */}
                          </div>
                        </div>
                      </div>

                      <div className="bottom-text text-center">
                        <p>
                          Didn't have an account? {"  "}
                          <Link to={route.register} className="text-underline">
                            Register!
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Login;
